import React, { useContext, useState } from "react";
import PortalModal from "../../Portals";
import {
  SectionWrapper,
  ContentDependency,
  CloseModalDependency,
  UL,
  ContentQ,
  StyledButton,
  OptionWrapper,
} from "./DependentQuestions.styled";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import { theme as themeConfig } from "../../themes/themes";
import { IconButton, Tooltip } from "@material-ui/core";
import { ContextQuestions } from "../../Store/StoreQuestions";
import AccountTreeIcon from "@material-ui/icons/AccountTree";

const DependentQuestions = ({
  dependency,
  saveDependencies,
  idQuestionSurvey,
  setshowDependency,
  showDependency,
}) => {
  const [stateQuestionsReducer] = useContext(ContextQuestions);
  const [Questions, setQuestions] = useState(
    JSON.parse(JSON.stringify(dependency))
  );

  const questionSelected = (q) => {
    let pos = Questions.findIndex(
      (f) => f.idQuestionSurvey == q.GidQuestionSurvey
    );
    if (pos === -1)
      setQuestions([
        ...Questions,
        {
          idQuestionSurvey: q.GidQuestionSurvey,
          isDependent: true,
          idParentQuestion: idQuestionSurvey,
          dependentAnswer: showDependency.answer,
        },
      ]);
    else {
      let allQuestions = [...Questions];
      allQuestions[pos] = {
        idQuestionSurvey: q.GidQuestionSurvey,
        isDependent: !allQuestions[pos].isDependent,
        idParentQuestion:
          allQuestions[pos].idParentQuestion === 0 ? idQuestionSurvey : 0,
        dependentAnswer:
          allQuestions[pos].dependentAnswer === "" ? showDependency.answer : "",
      };
      setQuestions(allQuestions);
    }
  };

  const fnChecked = (q) => {
    return (
      Questions.findIndex(
        (f) =>
          f.idQuestionSurvey === q.GidQuestionSurvey &&
          f.isDependent &&
          f.dependentAnswer === showDependency.answer
      ) !== -1
    );
  };

  return (
    <PortalModal>
      <ContentDependency>
        <CloseModalDependency>
          <Tooltip title="close">
            <IconButton
              onClick={() => {
                setQuestions(JSON.parse(JSON.stringify(dependency)));
                setshowDependency({ show: false });
              }}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModalDependency>
        <SectionWrapper>
          <label>
            <AccountTreeIcon style={{ fill: "#2f2f2f" }} />
            <span style={{ margin: "1em", color: themeConfig.text.primary }}>
              Select dependent questions to option:{" "}
            </span>
            <span style={{ color: themeConfig.text.primary, fontWeight: "800" }}>
              {showDependency.answer}
            </span>
          </label>
        </SectionWrapper>
        <UL>
          {stateQuestionsReducer.questions
            .filter((f) => {
              let questionsNotShown = Questions.filter(
                (f) => f.dependentAnswer != showDependency.answer
              );
              let posChildren = stateQuestionsReducer.questions.findIndex(
                (i) => f.GidQuestionSurvey == i.GidParentQuestion
              );

              return !(
                f.GidQuestionSurvey === idQuestionSurvey ||
                (questionsNotShown.length &&
                  questionsNotShown.findIndex(
                    (i) =>
                      i.idQuestionSurvey === f.GidQuestionSurvey &&
                      i.isDependent
                  ) > -1) ||
                (f.GisDependent && f.GidParentQuestion !== idQuestionSurvey) ||
                posChildren >= 0
              );
            })
            .map((q, i) => {
              return (
                <ContentQ key={i} className="dependency">
                  <label>{q.GnameQuestion}</label>
                  <OptionWrapper>
                    <input
                      type="checkbox"
                      onChange={() => questionSelected(q)}
                      defaultChecked={fnChecked(q)}
                    />
                  </OptionWrapper>
                </ContentQ>
              );
            })}
        </UL>
        <StyledButton
          onClick={() => {
            saveDependencies(Questions);
            setshowDependency({ show: false });
          }}
        >
          Save
        </StyledButton>
      </ContentDependency>
    </PortalModal>
  );
};

export default DependentQuestions;
